// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"P_8hazFfoxWScFOp3S3cp","settingsTitle":"_1img323ZVqdp72UP7XvpqE","settingsDescription":"_13CqASIGRI7llkMzgbgUMQ","settingsText":"_3tRR2vJikE8BQGLxnEbYnJ"};